import { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import Card from 'app/frontend/base/components/Card'
import AssignmentReminderTimeBadge from './AssignmentReminderTimeBadge'

type Props = {
  index: number
  label: ReactNode
  className?: string
  endSlot?: ReactNode
  warning?: boolean
  info?: boolean
  offsetSeconds?: number
  cascadeSeconds?: number
}

const AssignmentEntityChip = ({
  index,
  label,
  className,
  endSlot,
  warning,
  info,
  offsetSeconds,
  cascadeSeconds,
}: Props) => {
  const toneClass = warning
    ? 'bg-warning hover:bg-warning'
    : info
    ? 'bg-info hover:bg-info'
    : ''
  return (
    <Card
      className={cn(
        'flex min-w-0 items-stretch overflow-hidden text-sm p-0',
        toneClass,
        className,
      )}
    >
      <span
        className={cn(
          'inline-flex w-8 shrink-0 items-center justify-center border-r tabular-nums',
          toneClass || 'border-border',
        )}
      >
        {index + 1}
      </span>
      <span className='flex min-w-0 flex-1 items-center overflow-hidden px-2 py-1 gap-1'>
        <span className='flex min-w-0 flex-1 items-center justify-start overflow-hidden *:min-w-0 *:max-w-full'>
          {label}
        </span>
        <AssignmentReminderTimeBadge
          offsetSeconds={offsetSeconds}
          cascadeSeconds={cascadeSeconds}
        />
      </span>
      {endSlot ? (
        <span
          className={cn(
            'inline-flex items-center border-l px-1',
            toneClass || 'border-border',
          )}
        >
          {endSlot}
        </span>
      ) : null}
    </Card>
  )
}

export default AssignmentEntityChip
